var render = function render(){var _vm=this,_c=_vm._self._c;return _c('row',{attrs:{"gutter":16}},[_c('i-col',{attrs:{"span":_vm.contractPage ? '8' : '12'}},[_c('div',{staticClass:"ms-text"},[_vm._v("\n      Сумма заявленных требований от Компании\n    ")]),_c('alert',[_vm._v(_vm._s(_vm.getFormattedCosts(
        _vm.contractPage ? _vm.stats.from_company_law_cases_value : _vm.stats.from_company,
        false,
        _vm.withVat
      )))])],1),_c('i-col',{attrs:{"span":_vm.contractPage ? '8' : '12'}},[_c('div',{staticClass:"ms-text"},[_vm._v("\n      Сумма заявленных требований к Компании\n    ")]),_c('alert',{attrs:{"type":"error"}},[_vm._v("\n      "+_vm._s(_vm.getFormattedCosts(
          _vm.contractPage ? _vm.stats.on_company_law_cases_value : _vm.stats.on_company,
          false,
          _vm.withVat
        ))+"\n    ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }